import { render, staticRenderFns } from "./resolve.vue?vue&type=template&id=7826d38c&scoped=true"
import script from "./resolve.vue?vue&type=script&lang=js"
export * from "./resolve.vue?vue&type=script&lang=js"
import style0 from "./resolve.vue?vue&type=style&index=0&id=7826d38c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826d38c",
  null
  
)

export default component.exports